import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { Router } from '@angular/router';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { AppService } from '../app.service';
@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.scss']
})
export class ResetpasswordComponent implements OnInit {
  resetData: any = {
    userName: "",
    oldPassword: "",
    newPassword: ""
  };

  constructor(private dialogRef: MatDialogRef<ResetpasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private snackBar: MatSnackBar, private appService: AppService
  ) {
    this.data = data;
    this.resetData.orgId = data.orgId
    this.resetData.userName = this.data.userDetails.userName;
  }
  onNoClick() {
    this.dialogRef.close();
  }
  ngOnInit(): void {
    console.log(this.data);
  }
  // visibleAddAndEditPassword: boolean = true;
  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    //  this.visibleAddAndEditPassword = !this.visibleAddAndEditPassword;
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }

  //  visibleAddAndEditPassword: boolean = true;
  changetypeAddAndEditnewPassword: boolean = true;
  shownewPassword() {
    //   this.visibleAddAndEditPassword = !this.visibleAddAndEditPassword;
    this.changetypeAddAndEditnewPassword = !this.changetypeAddAndEditnewPassword;
  }

  close() {
    this.dialogRef.close();
  }
  resetPassword() {
    this.appService.resetPassword(this.resetData).subscribe((data: any) => {

      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        data: {
          message: data.RESULT_KEY,
          type: data.RESULT_TYPE_KEY == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok",
          pageName: "Login Page"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: data.RESULT_TYPE_KEY == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      if (data.RESULT_TYPE_KEY == 'S') {
        this.dialogRef.close();
      }
      //this.isProcessing = false;

      /* if(data.RESULT_TYPE_KEY=='E'){
         let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
           data:{
             message:data.RESULT_TYPE_KEY=='S'?"User logged in sucessfully": data.RESULT_KEY,
             type:data.RESULT_TYPE_KEY=='S'?'Success':'Error',
             buttonLabel:"Ok"
           },
           //duration: 5000,
           horizontalPosition: 'center',
           verticalPosition: 'top',
           panelClass: data.RESULT_TYPE_KEY=='S'?'Success':'Error',
         });
         sb.onAction().subscribe(() => {
           sb.dismiss();
         });
       }else if(data.RESULT_TYPE_KEY=="S"){
         //this.router.navigate(['/dashboard']);
         //this.router.navigateByUrl(this.redirectTo);
         let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
           data:{
             message:data.RESULT_TYPE_KEY=='S'?"User logged in sucessfully": data.RESULT_KEY,
             type:data.RESULT_TYPE_KEY=='S'?'Success':'Error',
             buttonLabel:"Ok"
           },
           //duration: 5000,
           horizontalPosition: 'center',
           verticalPosition: 'top',
           panelClass: data.RESULT_TYPE_KEY=='S'?'Success':'Error',
         });
         sb.onAction().subscribe(() => {
           sb.dismiss();
         });
       }*/

    })
  }
}
